// Paleta determinista de colores por miembro. Usada en Muro, Retos, Control Familiar...
export const MEMBER_PALETTE = [
  { ring: '#fbbf24', bg: 'rgba(251,191,36,0.15)', text: '#fcd34d', name: 'ámbar' },
  { ring: '#60a5fa', bg: 'rgba(96,165,250,0.15)', text: '#93c5fd', name: 'azul' },
  { ring: '#34d399', bg: 'rgba(52,211,153,0.15)', text: '#6ee7b7', name: 'menta' },
  { ring: '#f472b6', bg: 'rgba(244,114,182,0.15)', text: '#f9a8d4', name: 'rosa' },
  { ring: '#a78bfa', bg: 'rgba(167,139,250,0.15)', text: '#c4b5fd', name: 'lila' },
  { ring: '#fb7185', bg: 'rgba(251,113,133,0.15)', text: '#fda4af', name: 'coral' },
  { ring: '#22d3ee', bg: 'rgba(34,211,238,0.15)', text: '#67e8f9', name: 'turquesa' },
];

export const memberColor = (userId) => {
  if (!userId) return MEMBER_PALETTE[0];
  let h = 0;
  const s = String(userId);
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return MEMBER_PALETTE[h % MEMBER_PALETTE.length];
};

export const memberInitials = (nombre) => {
  if (!nombre) return '?';
  const parts = String(nombre).trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return parts[0].slice(0, 2).toUpperCase();
};
